var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"collapse d-lg-block navbar-collapse",attrs:{"id":"main-nav"}},[_c('div',{staticClass:"navbar navbar-expand-lg flex-column align-items-stretch align-items-lg-center"},[_c('NavbarContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }